import { render, staticRenderFns } from "./Extend.vue?vue&type=template&id=661bd1e7&scoped=true&"
import script from "./Extend.vue?vue&type=script&lang=js&"
export * from "./Extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661bd1e7",
  null
  
)

export default component.exports